import { DatePicker as BasicDatePicker, DatePickerProps as BasicDatePickerProps, } from "@basic-components";
import dayjs from "dayjs";
import { FC } from "react";


interface DatePickerProps extends Omit<BasicDatePickerProps, 'value'|'onChange'> {
    value?: string;
    onChange?: (range: string) => void;
    valueType?: 'string' | 'long';
    isView?: boolean;
}
export const DatePicker: FC<DatePickerProps> = ({value, format='YYYY-MM-DD', onChange, isView, valueType='long', ...props}) => {
    const formattedValue = value ? typeof value === 'number' ? dayjs(value) : dayjs(value, format as string) : null;
    const handleChange = (dates: any) => {
        const date = valueType === 'long' ? dates?.valueOf() : dates?.format(format)
        onChange?.(date);
    };
    if (isView) return value ? valueType === 'long' ? dayjs(value).format(format as string) : value : '--';
    return (
        <BasicDatePicker
         {...props}
         value={formattedValue}
          onChange={handleChange} />
    );
};